export type Environment = "production" | "preview" | "localhost";

const getEnvironment = (): Environment => {
  const environment = process.env.ENVIRONMENT as Environment;
  return environment;
};

export default getEnvironment;
